import {clientTransformed} from "@common/utils/rest";
import {HttpSuccessDto} from "@common/dto/http";
import {EmailTemplateListDto} from "@common/dto/email-template/list";

const URL_PREFIX = 'api/emailTemplates';

const getUrl = (path: string) => {
    return `${URL_PREFIX}/${path}`;
};

export const getEmailTemplates = (): Promise<Array<EmailTemplateListDto>> => {
    return clientTransformed({
        path: getUrl(''),
        method: 'GET',
    }).then(
        (response: HttpSuccessDto<Array<EmailTemplateListDto>>) => {
            return response.entity;
        },
    );
};